import { render } from "./invoice.vue?vue&type=template&id=84c3e7ea&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"

import "./invoice.vue?vue&type=style&index=0&id=84c3e7ea&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c3e7ea"]])

export default __exports__